<template>
  <div class="fy_cell flex flex-y-center flex-x-between">
    <div>
      <span class="required" v-if="required">*</span>
      <span class="label">{{label}}</span>
    </div>
    <input
      :type="type"
      v-model="inputValue"
      :placeholder="placeholder"
      :disabled="disabled"
      v-if="type!='datePicker'"
    />
    <date-picker
      v-model="inputValue"
      format="YYYY-MM-DD"
      value-type="format"
      :first-day-of-week="1"
      @change="changeDate"
      :clearable="false"
      :editable="false"
      v-else
    ></date-picker>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
export default {
  name: "",
  data() {
    return {
      currentValue: ""
    };
  },
  props: {
    // 输入框类型
    type: {
      type: String,
      default: "text"
    },
    //提示语
    placeholder: {
      type: String,
      default: ""
    },
    // 输入框描述
    label: {
      type: String,
      default: ""
    },
    //传入值
    inputValue: {
      type: String,
      default: ""
    },
    // 是否必填
    required: {
      type: Boolean,
      default: false
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    dateConfig: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    changeDate(val) {
      this.$emit("changeDate", val);
    }
  },
  watch: {
    inputValue(val) {
      console.log(val);
      this.currentValue = val;
    },
    currentValue(val) {
      console.log(val);
      this.$emit("update:inputValue", val);
    }
  },
  components:{DatePicker}
};
</script>

<style  scoped>
* {
  box-sizing: border-box;
  font-size: 0.7rem;
}
.fy_cell {
  width: 100%;
  height: 2.6rem;
  border-bottom: 0.05rem solid #eeeeee;
  background: #fff;
  padding: 0 0.5rem;
}
.fy_cell .required {
  color: #ff5e5e;
  font-weight: bold;
}
.fy_cell .label {
  color: #333;
}
.fy_cell input {
  width: 11rem;
  height: 100%;
}
.fy_cell input::-webkit-input-placeholder {
  /* placeholder颜色  */
  color: #999;
  /* placeholder字体大小  */
  font-size: 0.6rem;
}
</style>


// WEBPACK FOOTER //
// src/components/form/fyInput.vue